module.exports = __webpack_public_path__ + "img/10_reinhard_ld2a15.1e81ed25.png";